<template>
	<div id="menu">
		<p><span>FR</span>/<span>EN</span></p>
		<label id="labelSwitch" for="switchLanguage" v-bind:class="languagesSettings.lang !=  languagesSettings.defaultLang ? 'selected' : ''"></label>
		<input type="checkbox" id="switchLanguage" name="switchLanguage" v-on:click.stop="switchLang">
		<ul>
			<li v-if="showHomeButton"><a v-on:click="goToHome">{{fields[languagesSettings.lang].home}}</a></li>
			<li v-if="showCancelButton"><a v-on:click="cancelApplication" href="#">{{fields[languagesSettings.lang].cancel}}</a></li>
			<li><a v-on:click="logout" href="#">{{fields[languagesSettings.lang].logout}}</a></li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'hamburger',
	mounted : function(){
		let self = this;
		setInterval(()=>{
			var event = JSON.parse(localStorage.getItem("currentEvent"));
			if(event && new Date(event.endDate+"T23:59:59.000Z").getTime() < (new Date()).getTime())
				self.logout();
		},5000);
	},
	data() {
		return {
			currentLangIndex : 0,
			fields : {
				fr : {
					home  : 'Accueil',
					cancel : 'Annuler la candidature',
					logout : 'Déconnexion',
				},
				en : {
					home  : 'Home',
					cancel : 'Cancel current application',
					logout : 'Logout',
				}
			}
		};
	},
	props : ['languagesSettings', 'api', 'conf', 'view'],
	computed : {
		showHomeButton : function() {
			return this.conf && this.view && Array.isArray(this.conf.homeButton) && this.conf.homeButton.indexOf(this.view) > -1;
		},
		showCancelButton : function() {
			return typeof(this.view) == 'string' && this.view.length;
		}
	},
	methods : {
		switchLang : function() {
			let langSettings = this.languagesSettings;
			if(!Array.isArray(langSettings.langList)) return langSettings.lang = langSettings.defaultLang;
			if(++this.currentLangIndex >= langSettings.langList.length) this.currentLangIndex = 0;
			langSettings.lang = langSettings.langList[this.currentLangIndex];
		},
		logout : function() {
			if(window.navigator.onLine === true){
				let self = this;
				localStorage.clear();
				self.api.logout().finally(() => self.$router.push({name : 'loginPage'}));
			}
		},
		cancelApplication : function() {
			this.$emit('hamburgerEvent', 'cancelApplication');
		},
		goToHome : function(){
			this.$emit('hamburgerEvent', 'homeButton');
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/hamburger.vue